export default {
  producer: {
    title: "Block Producers",
    list: {
      empty: "No producers",
      header: {
        rank: "#",
        name: "Name",
        voteReceived: "Vote Received",
        blockProducedCount: "Block Prod. Nb",
        transactionProcessedCount: "Transac. Prod. Nb"
      }
    }
  }
}
